import ArrowLeftIcon from '@elementor/icons/ArrowLeftIcon';
import InfoCircleIcon from '@elementor/icons/InfoCircleIcon';
import Box from '@elementor/ui/Box';
import Chip from '@elementor/ui/Chip';
import IconButton from '@elementor/ui/IconButton';
import Infotip from '@elementor/ui/Infotip';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';
import { BLOCK_INFO, BLOCK_TITLES, BLOCKS } from '@constants';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import { removeExistingFocus } from '@utils/focus-on-element';
import { __ } from '@utils/i18n';

const Breadcrumbs = () => {
	const { openedBlock, sortedViolations, setOpenedBlock } =
		useScannerWizardContext();

	const handleClick = () => {
		removeExistingFocus(null);
		setOpenedBlock(BLOCKS.main);
	};

	const count = sortedViolations[openedBlock].length;

	return (
		<StyledBreadcrumbsBox>
			<IconButton
				color="secondary"
				onClick={handleClick}
				sx={{ whiteSpace: 'nowrap' }}
				aria-label={__('Return to all issues')}
				size="small"
			>
				<ArrowLeftIcon />
			</IconButton>

			<Box display="flex" alignItems="center" gap={1}>
				<Typography variant="subtitle2" as="h3">
					{BLOCK_TITLES[openedBlock]}
				</Typography>

				{BLOCK_INFO[openedBlock] && (
					<Infotip
						tabIndex="0"
						PopperProps={{
							disablePortal: true,
						}}
						content={
							<Typography variant="body2" sx={{ p: 2, maxWidth: '300px' }}>
								{BLOCK_INFO[openedBlock]}
							</Typography>
						}
					>
						<InfoCircleIcon fontSize="small" color="action" />
					</Infotip>
				)}
				{count > 0 && (
					<Chip label={count} color="error" variant="standard" size="small" />
				)}
			</Box>
		</StyledBreadcrumbsBox>
	);
};

const StyledBreadcrumbsBox = styled(Box)`
	display: flex;
	align-items: center;

	margin-top: ${({ theme }) => theme.spacing(1)};
	padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(2)}`};
	gap: ${({ theme }) => theme.spacing(1)};

	background-color: ${({ theme }) => theme.palette.background.default};
`;

export default Breadcrumbs;
